import React from "react";

const AppML_Case_Products = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case Products</h1>
      <p>This is the AppML Case Products page content.</p>
    </div>
  );
};

export default AppML_Case_Products;
